import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectManagerSelectValue = createSelector(
  [selectComposedReportState],
  ({ managers }) => managers
)
